export default __webpack_public_path__ + "static/media/필라테스_웹.15fa1c3f.jpg";